import { IBranch, ICGMBranch } from "../store/cgmBranchesReducer";

export const SET_CGM_BRANCHES = "SET_CGM_BRANCHES";
export const ADD_CGM_BRANCH = "ADD_CGM_BRANCH";
export const REMOVE_CGM_BRANCH = "REMOVE_CGM_BRANCH";
export const TOGGLE_CGM_FORM_OPEN = "TOGGLE_CGM_FORM_OPEN";
export const ADD_CGM_CRITICAL_BRANCH = "ADD_CGM_CRITICAL_BRANCH";
export const ADD_CGM_OUTAGE = "ADD_CGM_OUTAGE";
export const RESET_CGM_CRITICAL_BRANCH = "RESET_CGM_CRITICAL_BRANCH";
export const REMOVE_CRITICAL_BRANCH_CGM = "REMOVE_CRITICAL_BRANCH_CGM";
export const REMOVE_OUTAGE_CGM = "REMOVE_OUTAGE_CGM";
export const TOGGLE_CGM_TIME_INTERVALS = "TOGGLE_CGM_TIME_INTERVALS";
export const SET_CGM_COUNTRY = "SET_CGM_COUNTRY";
export const SET_CGM_LORT = "SET_CGM_LORT";
export const SET_CGM_VOLTAGE = "SET_CGM_VOLTAGE";
export const SET_CGM_CRITICAL_BRANCH_BRANCH_INPUT =
    "SET_CGM_CRITICAL_BRANCH_BRANCH_INPUT";
export const SET_CGM_OUTAGE_BRANCH_INPUT = "SET_CGM_OUTAGE_BRANCH_INPUT";
export const SET_CGM_OUTAGE_BRANCH_EIC = "SET_CGM_OUTAGE_BRANCH_EIC";
export const SET_CGM_INPUT = "SET_CGM_INPUT";

export const SetCGMBranches = (branches: ICGMBranch[]) => {
    return { type: SET_CGM_BRANCHES, branches };
};
export const AddCGMBranch = (branch: ICGMBranch) => {
    return { type: ADD_CGM_BRANCH, branch };
};
export const RemoveCGMBranch = (branch: ICGMBranch) => {
    return { type: REMOVE_CGM_BRANCH, branch };
};
export const ToggleCGMFormOpen = (opt: boolean) => {
    return { type: TOGGLE_CGM_FORM_OPEN, opt };
};
export const AddCGMCriticalBranch = (branch: IBranch) => {
    return { type: ADD_CGM_CRITICAL_BRANCH, branch };
};
export const AddCGMOutage = (branch: IBranch) => {
    return { type: ADD_CGM_OUTAGE, branch };
};
export const ResetCGMCriticalBranch = () => {
    return { type: RESET_CGM_CRITICAL_BRANCH };
};
export const RemoveCriticalBranchCGM = () => {
    return { type: REMOVE_CRITICAL_BRANCH_CGM };
};
export const RemoveOutageCGM = (key: string) => {
    return { type: REMOVE_OUTAGE_CGM, key };
};
export const ToggleCGMTimeIntervals = (timestamp: number) => {
    return { type: TOGGLE_CGM_TIME_INTERVALS, timestamp };
};
export const SetCGMCountry = (country: string) => {
    return { type: SET_CGM_COUNTRY, country };
};
export const SetCGMLort = (lort: string) => {
    return { type: SET_CGM_LORT, lort };
};
export const SetCGMVoltage = (voltage: string) => {
    return { type: SET_CGM_VOLTAGE, voltage };
};
export const SetCGMCriticalBranchBranchInput = (e: any) => {
    return { type: SET_CGM_CRITICAL_BRANCH_BRANCH_INPUT, e };
};
export const SetCGMOutageBranchInput = (e: any) => {
    return { type: SET_CGM_OUTAGE_BRANCH_INPUT, e };
};
export const SetCGMOutageBranchEic = (key: string, val: string) => {
    return { type: SET_CGM_OUTAGE_BRANCH_EIC, key, val };
};
export const SetCGMInput = (e: any, data?: any) => {
    return { type: SET_CGM_INPUT, e, data };
};
